module.exports = __webpack_public_path__ + "static/media/Animation_ok_Bloom.d835de8f.gif";